export const psRed = "#FF3939";
export const psGray = "#E2E2E2";
export const psLightGray = "#F6F6F6";
export const psBlack = "#222222";
export const whileTap = {
  scale: 0.9,
  backgroundColor: "#dddddd",
};
export const whileHover = {
  backgroundColor: "#dddddd",
  transition: { duration: 0.25 },
};
export const whileHoverButton = {
  backgroundColor: "#FF7070",
  transition: { duration: 0.25 },
};
export const whileTapButton = {
  scale: 0.9,
  backgroundColor: "#FF7070",
};
